module.exports = __webpack_public_path__ + "static/img/Reproductive-health_icon-21.8d77cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/non-invasive-prenatal-test/Reproductive-health_icon-21.png
// module id = p86d
// module chunks = 0